"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RefreshTokenFailedException = void 0;
class RefreshTokenFailedException extends Error {
    constructor() {
        super('RefreshTokenFailedException');
    }
}
exports.RefreshTokenFailedException = RefreshTokenFailedException;
//# sourceMappingURL=RefreshTokenFailedException.js.map